/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./speechBar.vue?vue&type=template&id=a36c1dd4&scoped=true&"
import script from "./speechBar.vue?vue&type=script&lang=js&"
export * from "./speechBar.vue?vue&type=script&lang=js&"
import style0 from "./speechBar.vue?vue&type=style&index=0&id=a36c1dd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36c1dd4",
  null
  
)

export default component.exports